import { dataHooks } from '@wix/data-hooks'

export const wixMobileDomainDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  input: {}
  next: {}
  back: {}
  skip: {}
  successMessage: {}
  domainBanner: {}
}>('wix-mobile-domain')
